
import { Badge } from "@/components/ui/badge";
import React from "react";

export const formatCurrency = (amount: number | null) => {
  if (amount === null || amount === undefined || (typeof amount === 'number' && isNaN(amount))) {
    console.log('Attempt to format invalid currency value:', amount);
    return '-';
  }
  
  try {
    console.log(`Formatting amount: ${amount}, type: ${typeof amount}`);
    // Ensure the amount is treated as a number
    const numAmount = Number(amount);
    
    if (isNaN(numAmount)) {
      console.error('Amount could not be converted to a number:', amount);
      return '-';
    }
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numAmount);
  } catch (error) {
    console.error('Error formatting currency:', error, 'Amount:', amount, 'Type:', typeof amount);
    return '-';
  }
};

export const getStatusBadge = (status: string) => {
  const variants: Record<string, string> = {
    pending: 'bg-yellow-500',
    accepted: 'bg-green-500',
    declined: 'bg-red-500',
    interested: 'bg-blue-500'
  };
  
  return <Badge className={variants[status] || 'bg-gray-500'}>{status}</Badge>;
};
